import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import ROUTES from "../../docRoutes/docRoutes";
import { userLoginAction } from "../../Redux/actions/authAction";
import { userInfoAction } from "../../Redux/actions/userInfoAction";
import { useFetch } from "../../Services/useFetch";
import { exchangeSsoCode, markSsoSession } from "../../utils/docGridSso";

// Landing page after the central IDP sign-in. The backend callback redirects
// here with a one-time code in the URL fragment; it is exchanged for the
// normal DocGrid login response, then the session is set up as Login.js does.
const SsoComplete = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { request } = useFetch();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const code = new URLSearchParams(window.location.hash.slice(1)).get("code");
    // Drop the code from the address bar and history.
    window.history.replaceState(null, "", window.location.pathname);

    const completeSignIn = async () => {
      try {
        if (!code) throw new Error("missing code");

        const res = await exchangeSsoCode(code);
        if (res?.data?.status !== "1") throw new Error("exchange failed");

        dispatch(userLoginAction(res.data));
        localStorage.setItem("docGridToken", res.data.token);
        markSsoSession();

        const formData = new URLSearchParams();
        formData.append("user_id", Number(res.data.data?.id));
        const response = await request("/user-details-edit", "post", formData, {
          "Content-Type": "application/x-www-form-urlencoded",
        });
        if (String(response?.data?.status) === "1") {
          dispatch(userInfoAction({ ...response.data.data }));
        }

        navigate(ROUTES.BRIEFCASE, { replace: true });
      } catch (_error) {
        navigate(`${ROUTES.LOGIN}?authError=sso_failed`, { replace: true });
      }
    };

    completeSignIn();
  }, [dispatch, navigate, request]);

  return (
    <div className="login_body">
      <div className="formWarpper">
        <div className="section-title text-center">
          <h1>Signing you in…</h1>
        </div>
      </div>
    </div>
  );
};

export default SsoComplete;
